import React from 'react';
import {
  Leaderboard,
  StackedBarChart,
} from '@mui/icons-material';
import GlobalSidebar from '../Global Sidebar/GlobalSidebar';
const iconSx = { color: '#ffffff' };

const MyPerformanceSideBar = () => {
  const performanceTabList = [{
    title: 'My Performance',
    tabs: 
    [
      {
        iconSource: <StackedBarChart sx={iconSx} />,
        title: 'My Performance',
        navigateTo: '/my-performance/Performance',
        bgColor: '#3F51B5',
      },
      {
        iconSource: <Leaderboard sx={iconSx} />,
        title: 'My Network Performances',
        navigateTo: '/my-performance/VCPPerformanceDirectory',
        bgColor: '#424242',
      },
    ],
  },
];
  return (
    <GlobalSidebar sections={performanceTabList} />
  );
};

export default MyPerformanceSideBar;
